import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn, } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class LoginValidationService {

  constructor() { }

  // Validator function to check the character length
  isLengthMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => (control.value && control.value.length >= 12 && control.value.length <=35 ) ? null : { length : true };
  }

  isMinLengthMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => (control.value && control.value.length >= 12) ? null : { length : true };
  }

  // Validator function to check for 8 char min on legacy passwords when updating to 12
 isMinLengthMetLegacy(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => (control.value && control.value.length >= 8) ? null : { length : true };
  }

  // Validator function to check the uppercase character presence
  isUppercaseMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => ((/[A-Z]/).test(control.value)) ? null : { upperChar: true };
  }

  // Validator function to check the lowercase character presence
  isLowercaseMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => ((/[a-z]/).test(control.value)) ? null : { lowerChar: true };
  }

  isUpperandLowercaseMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const hasUpperCase = /[A-Z]/.test(control.value);
      const hasLowerCase = /[a-z]/.test(control.value);

      if (hasUpperCase && hasLowerCase) {
        return null;
      } else {
        return { upperAndLowerChar: true };
      }
    };
  }

  isConsecutiveCharactersMet(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const consecutiveCharPattern = /(.)\1\1/;
      const hasConsecutiveChars = consecutiveCharPattern.test(control.value);

      return hasConsecutiveChars ? { consecutiveChars: true } : null;
    };
  }

  // Validator function to check the at least one number presence
  isOneNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => ((/[0-9]/).test(control.value)) ? null : { oneNumber: true };
  }

  // Validator function to check presence of first/last name or password

  noSpecialChar(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null =>  (/[\s~'"<>]/).test(control.value) ? { specialChar: true } : null;
  }

  emailPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null =>  (/^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+\=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/).test(control.value) ? null : { emailPattern: true };
  }

  // Validator function to check the password match
  confirmPasswordMatch(newPassword: string, confirmPassword: string) {
    return (formGroup: UntypedFormGroup): void => {
      const password = formGroup.controls[newPassword];
      const conPassword = formGroup.controls[confirmPassword];
      if (conPassword.value !== '' && conPassword.value !== null) {
        (password.value !== conPassword.value) ? conPassword.setErrors({ passMatch: true }) : conPassword.setErrors(conPassword.errors);
      }
    };
  }

  /**
   * Refactored validator function for password match check
   * */
  passwordMatchValidator(form: UntypedFormGroup): any {
    return form.get('newPassword').value === form.get('confirmPassword').value
      ? null : { mismatch: true };
  }

  containUserInfoWithForm(userInfo: any[], formRef?: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const nameToMatch = control.value?.toLowerCase();
    
    if (!nameToMatch || !userInfo || userInfo.length === 0) {
      return null;
    }

    const allUserInfoToCheck = [...userInfo];
    
    // Use provided form reference or try to get parent
    const targetForm = formRef || control.parent;
    
    if (targetForm) {
      const formUserId = targetForm.get?.('userId')?.value?.toLowerCase() || '';
      
      if (formUserId && formUserId.length > 2) {
        const isAlreadyInUserInfo = userInfo.some(info => 
          info && info.toLowerCase().trim() === formUserId
        );
        
        if (!isAlreadyInUserInfo) {
          allUserInfoToCheck.push(formUserId);
        }
      }
    }
    
    for (const element of allUserInfoToCheck) {
      if (element && typeof element === 'string' && element.length > 2) {
        if (nameToMatch.includes(element.toLowerCase().trim())) {
          return { userInfo: true };
        }
      }
    }
    
    return null;
  };
}
}
